import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import trackEvent from "../../services/track-event";

import styles from "./result.module.scss";

function Result({id, description, title, link, variant}) {
  return (
    <Grid
      container
      spacing={24}
      className={classNames(styles.root, styles[`root_${variant}`])}
    >
      <Grid item xs={12} md={5}>
        <div className={classNames(styles.image, styles[`image_${id}`])}></div>
      </Grid>
      <Grid item xs={12} md={7}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <a
          href={link}
          className={styles.link}
          onClick={() =>
            trackEvent({
              category: `quiz-button`,
              action: `quiz result click`,
              label: id
            })
          }
        >
          Подробнее
        </a>
      </Grid>
    </Grid>
  );
}

Result.propTypes = {
  id: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  variant: PropTypes.string
};

export default Result;
